/**
 *-------------------------------------------
 * create language info actions in redux
 *-------------------------------------------
 */

export const getLang = () => {
    return {
        type: 'GET_LANG'
    }
}

export const updateLang = (lang) => {
    return {
        type: 'UPDATE_LANG',
        lang
    }
}
